import { EventPackage } from "../models/AssignedSeating";
import { EventSeatmap, SectionSeatStatus } from "../models/Event";
import axios from "./axios";
import { BuildPortalUri, BuildUri } from "./BuildUri";
import portalAxios from "./portalAxios";

class SeatmapEndpoints {
    static async getEventSeatmapStatus(
        clientId: number,
        eventSeatmapId: number,
        seatId: number,
    ) {
        return (
            await portalAxios.get<any>(
                BuildPortalUri(
                    `/seatmap-status/{clientId}/seat/{eventSeatmapId}/{seatId}`,
                    { clientId, eventSeatmapId, seatId },
                ),
            )
        ).data;
    }

    static async getPackageStatus(
        clientId: number,
        eventPackageId: number,
        seatId: number,
    ) {
        return (
            await portalAxios.get<any>(
                BuildPortalUri(
                    `/seatmap-status/{clientId}/package/{eventPackageId}/{seatId}`,
                    { clientId, eventPackageId, seatId },
                ),
            )
        ).data;
    }

    static async getEventSeatmapLayout(eventSeatmapId: number) {
        return (
            await axios.get<EventSeatmap>(
                BuildUri(`/seatmap/event-seatmap/{eventSeatmapId}/layout`, {
                    eventSeatmapId,
                }),
            )
        ).data;
    }

    static async getEventSeatmapStatuses(eventSeatmapId: number) {
        return (
            await axios.get<SectionSeatStatus[]>(
                BuildUri(`/seatmap/event-seatmap/{eventSeatmapId}/status`, {
                    eventSeatmapId,
                }),
            )
        ).data;
    }

    static async getEventPackageStatuses(eventPackageId: number) {
        return (
            await axios.get<SectionSeatStatus[]>(
                BuildUri(`/seatmap/event-package/{eventPackageId}/status`, {
                    eventPackageId,
                }),
            )
        ).data;
    }

    static async getEventPackageLayout(eventPackageId: number) {
        return (
            await axios.get<{
                layout: EventSeatmap;
                eventPackage: EventPackage;
            }>(
                BuildUri(`/seatmap/event-package/{eventPackageId}/layout`, {
                    eventPackageId,
                }),
            )
        ).data;
    }
}

export default SeatmapEndpoints;
